module.exports = __webpack_public_path__ + "static/media/empty-cartC.2edecd3d.png";